import { useCallback } from "react";

import { isEmpty } from "@s-libs/micro-dash";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";
import useRestQuery from "@/remoteState/useRestQuery";

const buildParamsString = (params) => {
  return isEmpty(params) ? "" : `?${new URLSearchParams(params).toString()}`;
};

const useSchoolDetailsGet = (schoolId, params = {}) => {
  const createSchoolDetailsRequest = useCallback(
    (payload = { schoolId, ...params }) => {
      const { schoolId: id, ...rest } = payload;
      const paramsString = buildParamsString(rest);
      const requestConfig = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };

      return new Request(
        `${MONOLITH_ORIGIN}/api/v2/school/${id}/${paramsString}`,
        requestConfig,
      );
    },
    [],
  );
  return useRestMutation(createSchoolDetailsRequest);
};

export const useSchoolGet = (id, params = null) => {
  const paramsString = buildParamsString(params);
  return useRestQuery(
    `${MONOLITH_ORIGIN}/api/v2/school/${id}/${paramsString}`,
    { skip: !id },
  );
};

export default useSchoolDetailsGet;
